import React, { useEffect, useState } from "react";
import AdminLayout from "./Common/AdminLayout";
import { FaSearch, FaFileExport, FaEye, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { ExportUser, FetchUsers, Pagination, UserCount } from "../../Redux/Slices/User";
import { BarLoader } from "react-spinners";
import toast from "react-hot-toast";
import { GetMyAllSubscription } from "../../Redux/Slices/JobPost";
import "../../asset/new/css/admin-modern.css";

const EmployerList = () => {
  const { usersData } = useSelector((state) => state?.User);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState("");
  const [packageDetails, setPackageDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  //View Subscription Details
  const handleView = async (data) => {
    let res = await GetMyAllSubscription(data?._id);
    await setUserDetails({ ...data, res });
    setModalOpen(true);
  };

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [filterUser, setFilterUser] = useState(usersData);

  useEffect(() => {
    const fetchData = async () => {
      let data = await Pagination("Employer", currentPage, itemsPerPage);
      setFilterUser(data?.users);
    };

    fetchData();
    let data;
    let prevPage = localStorage.getItem('prevPage');
    if (prevPage) {
      data = JSON.parse(prevPage);
    } else {
      data = {
        role: "Employer",
        page: 1,
        search: searchQuery
      };
    }
    dispatch(FetchUsers(data));
    document.title = "Employer";
    
    // Fetch total count
    const fetchCount = async () => {
      try {
        const countData = await UserCount();
        setTotalCount(countData?.employerCount || 0);
      } catch (error) {
        console.error("Error fetching count:", error);
      }
    };
    fetchCount();
  }, []);

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
  };

  const exportUser = async () => {
    try {
      setLoading(true);
      await ExportUser("Employer");
      setLoading(false);
      toast.success("User exported successfully");
    } catch (error) {
      setLoading(false);
      toast.error("Failed to export user");
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    let data = {
      role: "Employer",
      search: e.target.value,
      page: 1
    };
    dispatch(FetchUsers(data));
  };

  const handlePageChange = async (page) => {
    let data = {
      role: "Employer",
      page: page,
      search: searchQuery
    };
    dispatch(FetchUsers(data));
    localStorage.setItem('prevPage', JSON.stringify(data))
  };

  // Calculate visible page range
  let startPage = 1;
  let endPage = 1;

  if (usersData?.pagination) {
    startPage = Math.max(1, usersData.pagination.page - 2);
    endPage = Math.min(
      usersData.pagination.totalPages,
      usersData.pagination.page + 2
    );

    if (usersData.pagination.page <= 3) {
      endPage = Math.min(5, usersData.pagination.totalPages);
    } else if (
      usersData.pagination.page >=
      usersData.pagination.totalPages - 2
    ) {
      startPage = Math.max(1, usersData.pagination.totalPages - 4);
    }
  }

  // Package details
  const packaghandler = async (userId) => {
    let data = await GetMyAllSubscription(userId)
    setPackageDetails(data)
  };

  return (
    <AdminLayout
      title="Employers List"
      subtitle="Manage all registered employers"
      breadcrumbs={[
        { label: "Admin", active: false },
        { label: "Employers", active: true }
      ]}
    >
      {/* Table Card */}
      <div className="admin-table-wrapper">
        <div className="admin-table-header">
          <h3 className="admin-table-title">
            All Employers ({totalCount || 0})
          </h3>
          <div className="admin-table-actions">
            <div className="admin-table-search">
              <FaSearch className="admin-table-search-icon" size={14} />
              <input
                type="search"
                placeholder="Search employers..."
                value={searchQuery}
                onChange={handleSearch}
              />
            </div>
            <button 
              onClick={exportUser} 
              className="admin-btn admin-btn-primary"
              disabled={loading}
            >
              {loading ? (
                <BarLoader color="white" width={50} height={2} />
              ) : (
                <>
                  <FaFileExport /> Export
                </>
              )}
            </button>
          </div>
        </div>

              <div className="admin-table-container">
                {usersData?.docs && usersData?.docs[0]?.data?.length > 0 ? (
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th style={{ width: '80px' }}>Actions</th>
                        <th onClick={() => handleSort("company_name")} style={{ cursor: 'pointer' }}>
                          Company Name
                        </th>
                        <th onClick={() => handleSort("name")} style={{ cursor: 'pointer' }}>
                          Employer Name
                        </th>
                        <th onClick={() => handleSort("designation")} style={{ cursor: 'pointer' }}>
                          Designation
                        </th>
                        <th onClick={() => handleSort("email")} style={{ cursor: 'pointer' }}>
                          Email
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {usersData.docs[0].data.map((user, index) => (
                        <tr key={index}>
                          <td>
                            <button
                              onClick={() => {
                                handleView(user);
                                packaghandler(user?._id);
                              }}
                              className="admin-btn admin-btn-sm admin-btn-primary"
                              title="View Details"
                            >
                              <FaEye />
                            </button>
                          </td>
                          <td style={{ fontWeight: 500 }}>
                            {user?.experience[0]?.company_name ?? "N/A"}
                          </td>
                          <td>{user?.name || "N/A"}</td>
                          <td>{user?.experience[0]?.designation ?? "N/A"}</td>
                          <td>{user?.email || "N/A"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="admin-empty-state">
                    <div className="admin-empty-state-icon">
                      <FaSearch />
                    </div>
                    <h3 className="admin-empty-state-title">No Employers Found</h3>
                    <p className="admin-empty-state-description">
                      {searchQuery 
                        ? "Try adjusting your search criteria" 
                        : "No employers have registered yet"}
                    </p>
                  </div>
                )}
              </div>

              {/* Pagination */}
              {usersData?.pagination && usersData?.docs[0]?.data?.length > 0 && (
                <div className="admin-table-footer">
                  <div className="admin-table-info">
                    {(() => {
                      const currentPage = usersData.pagination.page || 1;
                      const pageLimit = usersData.pagination.limit || usersData.docs[0].data.length || 10;
                      const total = totalCount || 0;
                      const startItem = ((currentPage - 1) * pageLimit) + 1;
                      const endItem = Math.min(currentPage * pageLimit, total);
                      
                      return `Showing ${startItem} to ${endItem} of ${total} results`;
                    })()}
                  </div>
                  <div className="admin-pagination">
                    <button
                      className="admin-pagination-item"
                      onClick={() => handlePageChange(usersData.pagination.prevPage)}
                      disabled={!usersData.pagination.prevPage}
                    >
                      Previous
                    </button>
                    {Array.from(
                      { length: endPage - startPage + 1 },
                      (_, i) => startPage + i
                    ).map((page) => (
                      <button
                        key={page}
                        className={`admin-pagination-item ${
                          usersData.pagination.page === page ? "active" : ""
                        }`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    ))}
                    <button
                      className="admin-pagination-item"
                      onClick={() => handlePageChange(usersData.pagination.nextPage)}
                      disabled={!usersData.pagination.nextPage}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>

      {/* Modal */}
      {modalOpen && (
        <div className="admin-modal-backdrop" onClick={() => setModalOpen(false)}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h3 className="admin-modal-title">Employer Details</h3>
              <button 
                className="admin-modal-close"
                onClick={() => setModalOpen(false)}
              >
                <FaTimes />
              </button>
            </div>
            <div className="admin-modal-body">
              <div className="admin-form-group">
                <label className="admin-form-label">Mobile</label>
                <div style={{ padding: '0.625rem', background: 'var(--admin-bg-secondary)', borderRadius: 'var(--radius-md)' }}>
                  {userDetails?.mobile || "Not Available"}
                </div>
              </div>
              <div className="admin-form-group">
                <label className="admin-form-label">Company Website</label>
                <div style={{ padding: '0.625rem', background: 'var(--admin-bg-secondary)', borderRadius: 'var(--radius-md)' }}>
                  {userDetails?.experience?.[0]?.company_web ?? "Not Available"}
                </div>
              </div>
              <div className="admin-form-group">
                <label className="admin-form-label">Job Posting Quota</label>
                <div style={{ padding: '0.625rem', background: 'var(--admin-bg-secondary)', borderRadius: 'var(--radius-md)' }}>
                  {packageDetails?.total_job_postings || 0}
                </div>
              </div>
              <div className="admin-form-group">
                <label className="admin-form-label">CV Search Quota</label>
                <div style={{ padding: '0.625rem', background: 'var(--admin-bg-secondary)', borderRadius: 'var(--radius-md)' }}>
                  {packageDetails?.total_cv_searches || 0}
                </div>
              </div>
              <div className="admin-form-group">
                <label className="admin-form-label">GSTIN</label>
                <div style={{ padding: '0.625rem', background: 'var(--admin-bg-secondary)', borderRadius: 'var(--radius-md)' }}>
                  {userDetails?.gst || "Not Available"}
                </div>
              </div>
              <div className="admin-form-group">
                <label className="admin-form-label">Validity</label>
                <div style={{ padding: '0.625rem', background: 'var(--admin-bg-secondary)', borderRadius: 'var(--radius-md)' }}>
                  {userDetails?.res?.subscriptions.length > 0 ? (
                    <span>{userDetails?.res?.subscriptions[0]?.package?.validity_day} days</span>
                  ) : (
                    "Not Available"
                  )}
                </div>
              </div>
            </div>
            <div className="admin-modal-footer">
              <button 
                className="admin-btn admin-btn-secondary"
                onClick={() => setModalOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

export default EmployerList;
